import { useQuery } from '@pinia/colada';

import { TeamSubject } from '../interfaces/property-showing-agent.dto';
import { showingAgentsServiceFor } from '../services/showing-agents.service';
import { showingAgentsQueryKey } from './showing-agents.query';

/** Under the roster's key, so one invalidation refreshes the roster and every list after a change that fans out */
export function getPropertyShowingAgentsQueryKey(subject: TeamSubject) {
  return [showingAgentsQueryKey, subject.kind, subject.id];
}

/** A unit's or building's list, for its Team tab; the picker asks by unit through usePropertyShowingAgentsQuery */
export function useTeamShowingAgentsQuery(subject: () => TeamSubject) {
  return useQuery({
    key: () => getPropertyShowingAgentsQueryKey(subject()),
    enabled: () => Boolean(subject().id),
    query: () => showingAgentsServiceFor(subject()).getForProperty(subject().id),
  });
}

export function usePropertyShowingAgentsQuery(propertyId: () => string | undefined) {
  return useTeamShowingAgentsQuery(() => ({ kind: 'property', id: propertyId() ?? '' }));
}
